import { DELETE_USER, DELETE_USER_SUCCESS, DELETE_USER_FAIL, GENERATE_PASSWORD, GENERATE_PASSWORD_FAIL, GENERATE_PASSWORD_SUCCESS } from "./actionType"

const initialState = {
  error: "",
  success: "",
}

const DeleteUser = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_USER:
      state = {
        ...state,
      }
      break
    case DELETE_USER_SUCCESS:
      state = { ...state, success: action.payload }
      break
    case DELETE_USER_FAIL:
      state = { ...state, error: action.payload }
      break
  }
  return state
}

export default DeleteUser


//Generate password
const initialStatePassword = {
  error: "",
  success: "",  
  loader: false,
}

export const GeneratePasswordReducer = (state = initialStatePassword, action) => {
  switch (action.type) {
    case GENERATE_PASSWORD:
      state = {
        ...state,
        success:"",
        loader: true,
      }
      break
    case GENERATE_PASSWORD_SUCCESS:
      state = { ...state, success: action.payload, loader: false, }
      break
    case GENERATE_PASSWORD_FAIL:
      state = { ...state, error: action.payload, loader: false, }
      break
  }
  return state
}